import { makeCancellable, takeLatest } from "vuex-cancellable-actions";
import Logger from "./../lib/logger";
import util from "./../lib/util.js";
import { RepositoryFactory } from "./../repository/RepositoryFactory";

/** Repository */
const EvaRepository = RepositoryFactory.get("evaInfo");

export default {
  namespaced: true,
  state: {
    tmPointEvaDatasParam: {
      /** 登録地点避難情報リスト取得時刻 */
      dispTime: null,
    },
    /** 選択中地点避難情報リスト */
    selectedEvaList: [],
    /** 選択中地点避難情報詳細ファイル名リスト */
    selectedEvaDocList: [],
    /** 選択中地点避難情報詳細リスト */
    selectedEvaDetailList: [],
  },
  mutations: {
    /** API実行時のパラメータを設定 */
    setTmPointEvaDatasParam(state, appTime) {
      state.tmPointEvaDatasParam.dispTime = appTime;
    },
    /**
     * 選択中地点避難情報リスト
     * @param {*} state
     * @param {*} selectedEvaList 選択中地点の避難情報リスト
     */
    setSelectedEvaList(state, selectedEvaList) {
      Logger.debug("[evacuation]mut - setSelectedEvaList()");
      state.selectedEvaList = selectedEvaList;
    },
    /**
     * 選択中地点避難情報詳細リスト
     * @param {*} state
     * @param {*} selectedEvaDetailList 選択中地点避難情報詳細リスト
     */
    setSelectedEvaDetailList(state, selectedEvaDetailList) {
      Logger.debug("[evacuation]mut - selectedEvaDetailList()");
      state.selectedEvaDetailList = selectedEvaDetailList;
    },
  },
  actions: makeCancellable({
    /**
     * 選択中地点の避難情報リストを取得
     * @param {*}
     * @param {*} townCode 選択中地点の市町村コード
     */
    getSelectedEvaList: takeLatest(async function(
      { commit },
      { townCode, appTime }
    ) {
      Logger.debug(
        "[evacuation]act - getSelectedEvaList({*},{" + townCode + "})"
      );

      var selectedEvaList = [];
      var selectedEvaDocList = [];

      const { data: allEvaInfo } = await EvaRepository.getPrefEvaList();
      if (allEvaInfo != null) {
        let allEvaList = allEvaInfo.evacuationList;
        let delDuplicateEvaList = allEvaList.filter((ele, idx, arr) => {
          const docIdList = arr.map(ele => ele['documentId']);
          if (docIdList.indexOf(ele.documentId) === idx) {
            return ele;
          }
        });
        for (var eachEva of delDuplicateEvaList) {
          if (eachEva.townCode === townCode) {
            selectedEvaList.push(eachEva);
            selectedEvaDocList.push(eachEva.documentId);
          }
        }
      }
      // 取得時間をストアに格納
      commit("setTmPointEvaDatasParam", appTime);
      // 取得情報を保存
      commit("setSelectedEvaList", selectedEvaList);

      var selectedEvaDetailList = [];
      for (var docId of selectedEvaDocList) {
        const { data: selectedEva } = await EvaRepository.getSelectedEvaDetail(
          docId
        );

        // 表示する情報を抜き出す
        var selectedEvaInfo = [];
        var selectedIssueList = [];
        if (selectedEva != undefined) {
          if (selectedEva.header !== null) {
            selectedEvaInfo = [
              {
                title: "発令日時",
                value: util.formatDate24(
                  selectedEva.header.publishedDate,
                  "YYYY/MM/DD HH:mm"
                ),
              },
              {
                title: "発令組織",
                value: selectedEva.header.publishedOrganization,
              },
              {
                title: "発令部署",
                value: selectedEva.header.publishedOffice,
              },
              {
                title: "総世帯数",
                value: selectedEva.header.totalHouse.value,
                unit: selectedEva.header.totalHouse.unit,
              },
              {
                title: "総人数",
                value: selectedEva.header.totalNumber.value,
                unit: selectedEva.header.totalNumber.unit,
              },
              {
                title: "補足情報",
                value: selectedEva.header.complementaryInfo,
              },
            ];
          }
          if (selectedEva.detail !== null) {
            for (var area of selectedEva.detail.targetArea) {
              var issueSortTitle = null;
              if (area.issueSort === 1) {
                issueSortTitle = "高齢者等避難";
              } else if (area.issueSort === 2) {
                issueSortTitle = "避難勧告";
              } else if (area.issueSort === 3) {
                issueSortTitle = "避難指示";
              } else if (area.issueSort === 4) {
                issueSortTitle = "緊急安全確保";
              } else if (area.issueSort === 5) {
                issueSortTitle = "警戒区域";
              }

              let issue = {
                title: issueSortTitle,
                sort: area.issueSort,
                flag: area.issueLiftFlg,
                areas: area.areas,
              };

              selectedIssueList.push(issue);
            }
          }
          let selectedEvaDetail = {
            docId: docId,
            townName: selectedEva.header.townName,
            disasterName: selectedEva.header.disasterName,
            selectedEvaInfo: selectedEvaInfo,
            selectedIssueList: selectedIssueList,
          };
          selectedEvaDetailList.push(selectedEvaDetail);
        }
      }

      commit("setSelectedEvaDetailList", selectedEvaDetailList);
    }),
  }),
};
